import { createAction, props } from '@ngrx/store';
import { BulkItem, BulkMember, BulkTools } from './bulk-tools.model';


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record bulk tools'
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record bulk tools success', 
    props<{ singleData: BulkTools }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record bulk tools failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record bulk tools',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record bulk tools success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record bulk tools failure',
    props<{ error: string }>()
);

//Fetch Bulk Users
export const fetchBulkMembers = createAction(
    '[Data] fetch records bulk members'
);
export const fetchBulkMembersSuccess = createAction(
    '[Data] fetch records bulk members success', 
    props<{ members: BulkMember[], total: number }>()
);
export const fetchBulkMembersFail = createAction(
    '[Data] fetch records bulk members failure', 
    props<{ error: string }>()
);

//Fetch Bulk Users
export const fetchBulkHistory = createAction(
    '[Data] fetch records bulk history'
);
export const fetchBulkHistorySuccess = createAction(
    '[Data] fetch records bulk history success', 
    props<{ bulkItems: BulkItem[], total: number }>()
);
export const fetchBulkHistoryFail = createAction(
    '[Data] fetch records bulk history failure', 
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state bulk tools',
);